import {
  SpinningIcon,
  SpinningIconProps,
} from '@/components/animation/SpinningIcon/SpinningIcon';
import { RefreshCw05Icon } from '@/components/icons/RefreshCw05Icon';
import { COLORS } from '@/styles/tokens/colors';

export function RotatingArrows(props: Partial<SpinningIconProps>) {
  return (
    <SpinningIcon
      Icon={RefreshCw05Icon}
      size={16}
      color={COLORS.TEXT.SECONDARY}
      {...props}
    />
  );
}
